<template>
  <div class="compositeQuery">
    <el-form
      :model="compositeQuery"
      ref="queryForm"
      label-width="100px"
      label-position="right"
    >
      <template v-if="!expandMore">
        <el-row>
          <!-- 工作时期 -->
          <el-col :span="6">
            <el-form-item label="工作时期" prop="workperiod">
              <el-select
                v-model="compositeQuery.workperiod"
                clearable
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option label="二次革命" value="二次革命"></el-option>
                <el-option
                  label="抗战前期"
                  value="抗战前期1937-7-7含至1943-12-30含"
                ></el-option>
                <el-option
                  label="抗战后期"
                  value="抗战后期1943-12-30至1945-9-2含"
                ></el-option>
                <el-option label="解放战争" value="解放战争"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 服务项目 -->
          <el-col :span="6">
            <el-form-item label="服务项目" prop="itemcodes">
              <el-cascader
                v-model="compositeQuery.itemcodes"
                ref="refHandle"
                :options="serviceItems"
                :props="{
                  label: 'name',
                  value: 'code',
                  expandTrigger: 'hover',
                  emitPath: false,
                  multiple: true,
                }"
                collapse-tags
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <!-- 服务日期 -->
          <el-col :span="6">
            <el-form-item label="服务日期" prop="year">
              <!-- <el-date-picker
                v-model="compositeQuery.year"
                type="year"
                placeholder="选择年"
                value-format="yyyy"
                style="width: 100%"
              >
              </el-date-picker> -->
              <el-date-picker
                placeholder="服务日期"
                v-model="compositeQuery.year"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 100%"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 操作按钮 -->
          <el-col :span="6">
            <el-button type="primary" @click="startQuery">查询</el-button>
            <el-button @click="reset">重置</el-button>
            <el-button
              :icon="expandMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              type="text"
              @click="expandMore = !expandMore"
              >{{ expandMore ? "收起" : "更多条件" }}</el-button
            >
          </el-col>
        </el-row>
      </template>

      <!-- 更多查询条件 -->
      <template v-if="expandMore">
        <el-row>
          <!-- 姓名 -->
          <el-col :span="6">
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="compositeQuery.name"
                autocomplete="off"
                maxlength="10"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 性别 -->
          <el-col :span="6">
            <el-form-item label="性别" prop="sex">
              <el-select
                v-model="compositeQuery.sex"
                clearable
                multiple
                placeholder="请选择"
              >
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 是否健在 -->
          <el-col :span="6">
            <el-form-item label="是否健在" prop="alive">
              <el-select
                v-model="compositeQuery.alive"
                clearable
                multiple
                placeholder="请选择"
              >
                <el-option label="健在" value="健在"></el-option>
                <el-option label="已故" value="已故"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 出生日期 -->
          <el-col :span="6">
            <el-form-item label="出生日期" prop="birthday">
              <el-date-picker
                v-model="compositeQuery.birthday"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 100%"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 证件号码 -->
          <el-col :span="6">
            <el-form-item label="证件号码" prop="papersnum">
              <el-input
                v-model="compositeQuery.papersnum"
                autocomplete="off"
                maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 政治面貌 -->
          <el-col :span="6">
            <el-form-item label="政治面貌" prop="political">
              <el-select
                v-model="compositeQuery.political"
                clearable
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in politicalDic"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 入党时间 -->
          <el-col :span="6">
            <el-form-item label="入党时间" prop="partydate">
              <el-date-picker
                placeholder="选择日期"
                v-model="compositeQuery.partydate"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 100%"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 工作时期 -->
          <el-col :span="6">
            <el-form-item label="工作时期" prop="workperiod">
              <el-select
                v-model="compositeQuery.workperiod"
                clearable
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option label="二次革命" value="二次革命"></el-option>
                <el-option
                  label="抗战前期"
                  value="抗战前期1937-7-7含至1943-12-30含"
                ></el-option>
                <el-option
                  label="抗战后期"
                  value="抗战后期1943-12-30至1945-9-2含"
                ></el-option>
                <el-option label="解放战争" value="解放战争"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 离休时间 -->
          <el-col :span="6">
            <el-form-item label="离休时间" prop="petireddate">
              <el-date-picker
                placeholder="选择日期"
                v-model="compositeQuery.petireddate"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 100%"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 离休时职务 -->
          <el-col :span="6">
            <el-form-item label="离休时职务" prop="duty">
              <el-input
                v-model="compositeQuery.duty"
                autocomplete="off"
                maxlength="20"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 归属 -->
          <el-col :span="6">
            <el-form-item label="归属" prop="belonging">
              <el-select
                v-model="compositeQuery.belonging"
                clearable
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in belongingDic"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 类别 -->
          <el-col :span="6">
            <el-form-item label="类别" prop="category">
              <el-select
                v-model="compositeQuery.category"
                clearable
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in categoryDic"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 是否孤老 -->
          <el-col :span="6">
            <el-form-item label="是否孤老" prop="lonely">
              <el-select
                v-model="compositeQuery.lonely"
                clearable
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option label="孤老" value="孤老"></el-option>
                <el-option label="非孤老" value="非孤老"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <!-- 服务项目 -->
          <el-col :span="6">
            <el-form-item label="服务项目" prop="itemcodes">
              <el-cascader
                v-model="compositeQuery.itemcodes"
                ref="refHandle"
                :options="serviceItems"
                :props="{
                  label: 'name',
                  value: 'code',
                  expandTrigger: 'hover',
                  emitPath: false,
                  multiple: true,
                }"
                collapse-tags
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <!-- 服务日期 -->
          <el-col :span="6">
            <el-form-item label="服务日期" prop="year">
              <!-- <el-date-picker
                v-model="compositeQuery.year"
                type="year"
                placeholder="选择年"
                value-format="yyyy"
                style="width: 100%"
              >
              </el-date-picker> -->

              <el-date-picker
                placeholder="服务日期"
                v-model="compositeQuery.year"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 100%"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
              ></el-date-picker>


            </el-form-item>
          </el-col>

          <el-col :span="6" :offset="6">
            <el-button type="primary" @click="startQuery">查询</el-button>
            <el-button @click="reset">重置</el-button>
            <el-button
              :icon="expandMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              type="text"
              @click="expandMore = !expandMore"
              >{{ expandMore ? "收起" : "展开" }}</el-button
            >
          </el-col>
        </el-row>
      </template>
    </el-form>
  </div>
</template>

<script>
import { treeEmptyToUndefined } from "@/utils/index";
import { getDictionary } from "@/utils/recordUtils/getCacheForService.js";

export default {
  name: "CompositeQuery",
  data() {
    return {
      expandMore: false,
      serviceItems: [],
      organizations: [],
      dictionarys: [],
      compositeQuery: {
        //人员信息相关查询条件
        name: "",
        sex: [],
        birthday: [],
        alive:[],
        papersnum: "",
        political: [],
        partydate: [],
        workdate: [],
        workperiod: [],
        workunit: "",
        petireddate: [],
        duty: "",
        organizationid: [],
        belonging: [],
        category: [],
        lonely: [],

        // 服务信息相关查询条件
        itemids: [],
        itemcodes: [],
        year: [],
      },
    };
  },

  //计算属性
  computed: {
    //拆分系统字典
    //证件类型
    papersDic() {
      let dic = this.dictionarys.filter((x) => x.category == "证件类型");
      console.log(dic);
      return dic;
    },
    // 政治面貌
    politicalDic() {
      let dic = this.dictionarys.filter((x) => x.category == "政治面貌");
      return dic;
    },

    //校正后待遇
    treatmentDic() {
      let dic = this.dictionarys.filter((x) => x.category == "校正后待遇");
      return dic;
    },
    //医疗待遇
    medicalDic() {
      let dic = this.dictionarys.filter((x) => x.category == "医疗待遇");
      return dic;
    },
    //归属
    belongingDic() {
      let dic = this.dictionarys.filter((x) => x.category == "归属");
      return dic;
    },
    //类别
    categoryDic() {
      let dic = this.dictionarys.filter((x) => x.category == "类别");
      return dic;
    },
    //联系人关系
    contactRelationshiplDic() {
      let dic = this.dictionarys.filter((x) => x.category == "联系人关系");
      return dic;
    },
  },

  mounted() {
    this.initOrganzation();
    this.initServiceItem();
    this.initDictionary();
  },

  methods: {
    // 获取组织机构列表
    initOrganzation() {
      this.$axios
        .get("/cadresInfo/organization")
        .then((response) => {
          const { data } = response;
          treeEmptyToUndefined(data);
          this.organizations = data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //初始化服务项目
    initServiceItem() {
      this.$axios
        .get("/serviceRecord/serviceitem")
        .then((response) => {
          const { data } = response;
          treeEmptyToUndefined(data);
          this.serviceItems = data;
          this.diabledMenuForRole(this.serviceItems);
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },

    diabledMenuForRole(items) {
      //遍历树  获取id数组
      let disabledMenuName = [
        "政治生活",
        "传达文件",
        "区情通报",
        "政治学习",
        "组织生活",
        "法律讲座",
        "长护险",
        "助餐服务",
        "养老咨询",
      ];
      for (var i in items) {
        var item = items[i];
        if (disabledMenuName.includes(item.name)) {
          item["disabled"] = true;
        } else {
          item["disabled"] = false;
        }
        if (item.children && item.children.length > 0) {
          //存在子节点就递归
          this.diabledMenuForRole(item.children, disabledMenuName);
        }
      }
    },

    initDictionary() {
      getDictionary().then((reslut) => {
        this.dictionarys = reslut;
      });
    },

    startQuery() {
      this.$emit("query", this.compositeQuery);
    },
    reset() {
      // this.$refs.queryForm.resetFields();
      this.compositeQuery={
        //人员信息相关查询条件
        name: "",
        sex: [],
        birthday: [],
        alive:[],
        papersnum: "",
        political: [],
        partydate: [],
        workdate: [],
        workperiod: [],
        workunit: "",
        petireddate: [],
        duty: "",
        organizationid: [],
        belonging: [],
        category: [],
        lonely: [],

        // 服务信息相关查询条件
        itemids: [],
        itemcodes: [],
        year: [],
      };
    },
  },
};
</script>

<style lang="scss">
.compositeQuery {
  width: 100%;

  .el-form-item {
    margin-bottom: 0.3125rem;
  }
}
</style>
